'use client';

import { type ReactNode } from 'react';
import { CardFantasyItem } from '@/features/home/services/home';
import GameCardWithTracking from '@/features/home/components/game-card-with-tracking';

interface FantasyCardWithExposureProps {
  item: CardFantasyItem;
  index: number;
  currentPage?: string;
  currentModule?: string;
  children: (props: { cardRef: React.RefObject<HTMLDivElement | null>; handleNavigate: () => void; }) => ReactNode;
}

const CURRENT_PAGE = 'Home';
const CURRENT_MODULE = 'Fantasy';

export default function FantasyCardWithExposure({
  item,
  index,
  currentPage = CURRENT_PAGE,
  currentModule = CURRENT_MODULE,
  children,
}: FantasyCardWithExposureProps) {

  return (
    <GameCardWithTracking
      item={item}
      index={index}
      currentPage={currentPage}
      currentModule={currentModule}
      throttleWait={40 * 1000}
    >
      {({ cardRef, handleClick }) => children({ cardRef, handleNavigate: handleClick })}
    </GameCardWithTracking>
  );
}

